import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const getProduct = (id) =>
  privateAxios({
    method: 'get',
    baseURL: adminAPI,
    url: `/product/${id}`,
  });
